// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb-module--breadcrumbs--3VLg_","item":"breadcrumb-module--item--2-izn","separation":"breadcrumb-module--separation--3Ek7G"};